$(document).ready(function(){ 
  // Initialize Firebase

  var config = {
    apiKey: "AIzaSyDEe_-tIzKhmnQPwn2_jV2lMNmq5sgNQsE",
    authDomain: "gift-biz-customers-data.firebaseapp.com",
    databaseURL: "https://gift-biz-customers-data.firebaseio.com",
    projectId: "gift-biz-customers-data",
    storageBucket: "gift-biz-customers-data.appspot.com",
    messagingSenderId: "407069967167"
  };
  firebase.initializeApp(config);
$('.productDetail img').hide();

  $("body").on("click","#profileedit",function() {   //save profile data
 
    	var $name = $("#contactFormName").val();
    	var get_image_name = $("#upload_image").val();
        var get_mail_user = $(".get_customer_email").attr("attr-mail");
    	var newString= get_mail_user.substr(0, get_mail_user.indexOf('@'));
    
        firebase.database().ref('company/' + newString).update({
      name: $name
    });
    
    	 if(get_image_name){
      var storageRef = firebase.storage().ref(newString);
      var file_data = $('#upload_image').prop('files')[0];
      storageRef.put(file_data);
    }
    
    $("#contactFormName").val('');
    $("#upload_image").val('');
    $('.succ-msg').show();
    
  });
  /// form added

  $("body").on("click","#submit_form_inventory",function() {
    
    var mail = $("#cust_email").val();
    var order = $("#order_name").val();
    var pdf_link = $("#pdf_link").val();
    var order_price = $("#order_price").val();
    var date = Math.round((new Date()).getTime() / 1000);
   
     
    var newString= mail.substr(0, mail.indexOf('@')); 
    $(".onsuccess").show();
    $(".cust_form .cust_email").val('');


    firebase.database().ref('users/' + newString).update({
      email: mail,
      picture:newString,
      username: name,
      date:date
    });

    var requestData = { 
      products: [], 
      ink:pdf_link,
      order:order,
      order_price:order_price,
      order_time:date
       
    } 

    $('.active-product').each(function(i){ 
	  var customproduct ='';
      var productselected ='';
      var product_link = '';
      var productselected = $(this).find('.dropdown-selected').text();
      if(productselected == 'Other'){ 
        
        customproduct = $(this).find('.customproduct').val();
        product_link = $(this).find('.customproductlink').val();
        productselected = '';
      
      } //custom product
      else {productselected = productselected; }
     
      
      
      requestData.products.push({
        product_name:productselected,
        product_link:product_link,
        product_custom:customproduct
      });
      
      // PUSH DATA IN RECENT TABLE
    firebase.database().ref('recentorders').push({
      email: mail,
      a_orderNumber:order,
      date:date,
      product_link:product_link,
      product_name:productselected,
      product_custom:customproduct
      
    });
 });
    
// append all data to orders
    firebase.database().ref('users/'+newString+'/order').push(requestData);
 
 
       });

 
  
  
  
  //   CODE TO GET ALL DATA AND SHOW 
 
    firebase.database().ref('/users/').on("value",function(snapshot) {
         $(".orderdetail2").empty();
    snapshot.forEach(function(childSnapshot) {
      var childData = childSnapshot.val();
      var get_name = childSnapshot.key;
      
      if(get_name == 'picture'){
        getimge_url(childData);
      }

      var $time;
      var ordernumber;
      var pdf;
      var totalprice;
      var email ;
      childSnapshot.forEach(function(childd) {
        var childData = childd.key;
        var get_data = childd.val();
        if(childData == 'email'){ email = get_data; }
       
        childd.forEach(function(childdchildd) {
          var get_key = childdchildd.key;
          var childdchilddData = childdchildd.val();
          var Order_Index = get_key;
           
          childdchildd.forEach(function(orders) {
         	 var get_key = orders.key;
         	 var childdchilddData = orders.val();
           
            
            
                    if(get_key == 'order'){
 				ordernumber = childdchilddData;   
          }
          
          if(get_key == 'ink'){
            
            pdf = childdchilddData;
          }
          
          if(get_key == 'order_price'){
            totalprice  = childdchilddData;
          }
 
          
 			if(get_key == 'products'){

              var   $html ='<div class="orderNumber"><div class="Onum"><p>Order # '+ordernumber+'</p></div><div class="orderdate"></div><div class="viewInvoic"><p><u><a target="_blank" href="'+pdf+'">View Invoice:</a></u></p></div><div class="ordermenu" data-number="'+ordernumber+'" ><div class="panel-group"><div class="ordermenudown" ><span  data-orderNumber = "'+ordernumber+'" data-email="'+email+'" data-index="'+Order_Index+'" class="fa fa-trash-o delete"></span><span  data-orderNumber = "'+ordernumber+'" data-email="'+email+'" data-index="'+Order_Index+'" class="fa fa-edit edit"></span></div></div></div></div>';
             $('.orderdetail2').append($html);
              
              
              orders.forEach(function(product) {
                      var childData = product.key;
       				  var get_data = product.val();
                	
                	 var $name = get_data.product_name;
               		 
               	     var $custom = get_data.product_custom;
                
                if($name == '')
                {
 
         var  $newhtml =  '<div data-order="'+ordernumber+'" class="panel-collapse collapse"><div class="ALaptopSleevs"><div class="image"><img src="https://cdn.shopify.com/s/files/1/2030/7295/files/no-image.png?1333788481347587492" style="width: 100%;"></div><div class="productDetail"><b>'+$custom+'</b> </div></div></div>';
          //$(".orderdetail2").append($newhtml);
        	$(".no_order_yet").hide();
                  
          
                
                }
                    $(".all_products_box li").each(function(){
     			 var get_handle = $(this).attr("data-title").trim();
     			 var get_title = $(this).attr("data-title");
      			var get_image = $(this).attr("data-image");
      			var get_price = $(this).attr("data-price");
      			if(get_handle == $name  ){
                  
        			$(".no_order_yet").hide();
//           			 var  $newhtml =  '<div data-order="'+ordernumber+'" class="panel-collapse collapse"><div class="ALaptopSleevs"><div class="image"><img src="'+get_image+'" style="width: 100%;"></div><div class="productDetail"><b>'+get_title+'</b> </div></div></div>';
          			//	var $newhtml = '<div data-order="'+ordernumber+'" class="panel-collapse collapse"><input class="cust_email"  placeholder="Enter Email" name="email" value="'+email+'" required="" type="text"><input class="cust_email"  name="contact[name]" placeholder="Invoice Number" value="'+ordernumber+'"  type="text"><input class="cust_price"   name="contact[price]" placeholder="Price" value="'+totalprice+'" type="text"><input class="cust_email" id="pdf_link" name="contact[name]" placeholder="PDF link" value="'+pdf+'" type="text"></div>';
                  $(".orderdetail2").append($newhtml);
      			}
 
 
    });
                 
                     
              
              
              });
          }
            
          
          });
          
        });

      });
    });
  });
  
  
  
  // delete data from db
  $(document).on('click','.delete',function(){
   
    var getInd = $(this).attr('data-index');
    var getemail = $(this).attr('data-email');
    var orderNumb = $(this).attr('data-ordernumber');
    var username= getemail.substr(0, getemail.indexOf('@'));
   // delete data from recent orders     
	var eventContactsRef = firebase.database().ref('recentorders');  
	eventContactsRef.orderByChild('email').equalTo(getemail)
	    .once('value').then(function(snapshot) {
        snapshot.forEach(function(childSnapshot) {
        //remove each child
          childSnapshot.forEach(function(last) {
             	if(last.key == 'a_orderNumber' && last.val() == orderNumb )
             	{
					 var requestData = {};
                     var selectedKey =childSnapshot.key ;
                     requestData[selectedKey] = [];
                     firebase.database().ref('recentorders/').update(requestData);
                }
          
          });
//        
      });
	});
    
  
    //delete data from orders
var eventContactsRef = firebase.database().ref('users');  
eventContactsRef.orderByChild('email').equalTo(getemail)
    .once('value').then(function(snapshot) {
        snapshot.forEach(function(childSnapshot) {
        //remove each child
        
          childSnapshot.forEach(function(last) {
             
             	if(last.key == 'order' )
             	{
                 
                  var requestData = {};
                  last.forEach(function(orders) {
                     
                    if(orders.key  == getInd){
                    var selectedKey =orders.key ;
                    requestData[selectedKey] = [];
                    firebase.database().ref('users/'+username+'/order/').update(requestData);
                    
                    }
                  });
                
             }
          
          });
//        
      });
	});
  
 });
  
  
  

 	 
      
  //code for edit button
      

  $("body").on("click","#edit-orders-btn",function() {
    
    var mail = $("#cust_email1").val();
    var idx = $("#orderID").text();
    var order = $("#order_name1").val();
    var pdf_link = $("#pdf_link1").val();
    var order_price = $("#order_price1").val();
    var date = Math.round((new Date()).getTime() / 1000);
     
    var newString= mail.substr(0, mail.indexOf('@')); 
    $(".onsuccess").show();
    

//     first delete recent orders old and append again new updated orders
     var getemail = mail;
     var orderNumb = order;
     var username= getemail.substr(0, getemail.indexOf('@'));
   // delete data from recent orders     
  var eventContactsRef = firebase.database().ref('recentorders');  
  eventContactsRef.orderByChild('email').equalTo(getemail)
      .once('value').then(function(snapshot) {
        snapshot.forEach(function(childSnapshot) {
        //remove each child
          childSnapshot.forEach(function(last) {
              if(last.key == 'a_orderNumber' && last.val() == orderNumb )
              {
          			 var requestData = {};
                     var selectedKey =childSnapshot.key ;
                     requestData[selectedKey] = [];
                     firebase.database().ref('recentorders/').update(requestData);
                }
          
          });
//        
      });
  });
      
      
    //end updated 

    firebase.database().ref('users/' + newString).update({
      email: mail,
      picture:newString,
      username: name,
      date:date
    });

    var requestData = { 
      products: [], 
      ink:pdf_link,
      order:order,
      order_price:order_price,
      order_time:date
       
    } 
    

    $('.active-product').each(function(i){ 
		var customproduct ='';
      var productselected ='';
      var productselected = $(this).find('select option:selected').text();
      var product_link  = '';
      
       
      if(productselected == 'Other'){
        customproduct = $(this).find('.customproduct').val();
        product_link = $(this).find('.customproductlink').val();
        productselected = ''; } //custom product
      else {productselected = productselected; }
     
      
      
      requestData.products.push({
        product_name:productselected,
        product_link:product_link,
        product_custom:customproduct
      });
      
      setTimeout(function(){  
      
            // PUSH DATA IN RECENT TABLE
      firebase.database().ref('recentorders').push({
      email: mail,
      a_orderNumber:order,
      date:date,
      product_link:product_link,
      product_name:productselected,
      product_custom:customproduct
      
    });
         }, 2000);
      
 });

 
    
    
// append all data to orders
    firebase.database().ref('users/'+newString+'/order/'+idx).update(requestData);
    //   UPDATE CODE FOR RECENT ORDER TABLE


 
 
       });
  
  

//  sample test code of sort and recent records
  
  var recentPostsRef = firebase.database().ref('recentorders').orderByChild('date').limitToLast(4);
var arr = [];
  recentPostsRef.on("value", function(snapshot) {
 
     snapshot.forEach(function(childSnapshot) {   //l1
             var childData = childSnapshot.val();
     		 var get_name = childSnapshot.key;
   
        	 
            childSnapshot.forEach(function(childd) {   //l2
             var childData = childd.val();
     		 var get_key = childd.key;
                 
  
             
              if(get_key == 'date' )
              {
		    
                 arr.push({ date: childData  }); 
              }
              if(get_key == 'email' )
              {
                
               
                arr.push({ email: childData  });         
                 
              }
               if(get_key == 'product_link' )
              {
                
               
                arr.push({ product_link: childData  });         
                 
              }
 
             if(get_key == 'product_name'  || get_key == 'product_custom'  )
              {
                if(get_key == 'product_name' && childData != '' ){arr.push({ product_name: childData  });}
              
              	else if(get_key == 'product_custom' && childData != '' ) {arr.push({ product_name: childData  });}
              
              }
 
 
     

            });
     });
 		arr.reverse();
 		var $html = '';
        var $imgsrc ;
        var $productname;
        var $price ;
      	var $qty;
    	var placedby= '';
    	var test = '';
    	var $date;
   		var profile_img;
   		 var $url;
   		 var custom_link = '';
    	 $('.orderhistory').empty();
      console.log('working');
     console.log(arr);
 
    for (var k in arr){
  
      //for getting image of a product 
	
      $('.all_products_box li').each(function(){
     
        if($(this).attr('data-title') === arr[k]['product_name'] )
        {
           $imgsrc = $(this).attr('data-image');
           $url =   $(this).attr('data-handle');
        }
  
      });
     
      
      	if (typeof arr[k]['date'] != "undefined")
        { 
          $date = arr[k]['date'];
          var forimage= placedby.substr(0, placedby.indexOf('@'));
 		     	 var dateB = moment(parseInt($date )*1000);
                 var fromNow = moment(dateB, "YYYYMMDD").fromNow();
          
          $url = '/products/'+$url;
       
          if(typeof $imgsrc == "undefined" ){  $imgsrc = 'https://cdn.shopify.com/s/files/1/2030/7295/files/no-image.png?13337884813475874925'; }
          if(custom_link != ''){  $url= '';$url = custom_link;}
          $html = '<div class="productsection"><div class="nylonPuch"><div class="image"><a target="_blank" href="'+$url+'"><img src="'+$imgsrc+'" style="width: 100%;"></a></div><div class="productDetail"><a  target="_blank" href="'+$url+'"><p><strong>'+$productname+'</strong></p></a><p>Ordered Placed by  <strong class="c'+forimage+'"></strong></p><p><i class="fa fa-clock-o" aria-hidden="true"></i>'+fromNow+'</p><img class="'+forimage+'" src=""> </div></div></div>';    
			 $url = '';
          $('.orderhistory').append($html);
          $('.productDetail img').show();
          // get profile image
          profile_image(placedby);
         	var cname =  companyName(placedby);
          
          $imgsrc = 'https://cdn.shopify.com/s/files/1/2030/7295/files/no-image.png?13337884813475874925';
        }
 
        if (typeof arr[k]['email'] != "undefined"){ placedby = arr[k]['email']; }
        if (typeof arr[k]['product_link'] != "undefined"){ custom_link = arr[k]['product_link']; }

       
        if (typeof arr[k]['product_name'] != "undefined" && arr[k]['product_name'] != ''  ) {
          
           $productname =arr[k]['product_name'];
        }
    
    }
  });

 
  
  
 function companyName(user)
{
  
  var get_mail_user = user;
  var useremail = get_mail_user.substr(0, get_mail_user.indexOf('@')); 
  useremail = useremail.trim();
    //   company name
    firebase.database().ref('/company/'+useremail).once('value').then(function(snapshot) {
    //     console.clear();
    snapshot.forEach(function(childSnapshot) {
      var childData = childSnapshot.val();
      var get_name = childSnapshot.key;
      if(get_name == 'name'){
          
      
        $('.c'+useremail).empty();
        $('.c'+useremail).append(childData);
         
      }
    });
    });
  
  
  }


  var get_mail_user = $("#customerLogin").attr("data-email");
  var split_email = get_mail_user.substr(0, get_mail_user.indexOf('@')); 
  split_email = split_email.trim();
  
//   code for specific user data
  
//   company name
    firebase.database().ref('/company/'+split_email).once('value').then(function(snapshot) {
    //     console.clear();
    snapshot.forEach(function(childSnapshot) {
      var childData = childSnapshot.val();
      var get_name = childSnapshot.key;
      if(get_name == 'name'){
          
        $('.companyName').append(childData);
      }
    });
    });
  
  
  
  firebase.database().ref('/users/'+split_email).once('value').then(function(snapshot) {
    //     console.clear();
    snapshot.forEach(function(childSnapshot) {
      var childData = childSnapshot.val();
      var get_name = childSnapshot.key;
      if(get_name == 'picture'){
        getimge_url(childData);
      }

      var $time;
      var ordernumber;
      var pdf;
      var totalprice;
      childSnapshot.forEach(function(childd) {
        var childData = childd.key;
        var get_data = childd.val();
      
        $(".order_history_customer").append('<div class="order-grid" id="'+childData+'"></div>');
        childd.forEach(function(childdchildd) {
          var get_key = childdchildd.key;
          var childdchilddData = childdchildd.val();
    
 
                 if(get_key == 'order_time'){
                   
          var d = new Date(childdchilddData*1000);
           var curr_date = d.getDate();
			var curr_month = d.getMonth();
			var curr_year = d.getFullYear();
                 $time =curr_date+'/'+curr_month+'/'+curr_year ;
              }
          
          if(get_key == 'order'){
 				ordernumber = childdchilddData;
//             get_order_no(childdchilddData,childData);
             
          }
          
          if(get_key == 'ink'){
            
            pdf = childdchilddData;
//            console.log('ink:'+childdchilddData);
            
            get_order_link(childdchilddData,childData);
          }
          
          if(get_key == 'order_price'){
            totalprice  = childdchilddData;

//              console.log('orderprice:'+childdchilddData);
             get_order_price(childdchilddData,childData);
          }
 
          
 			if(get_key == 'products'){
	
              var   $html ='<div class="orderNumber"><div class="Onum"><p>Order # '+ordernumber+'</p></div><div class="orderdate"><p>'+$time+'</p></div><div class="viewInvoic"><p><u><a target="_blank" href="'+pdf+'">View Invoice:</a></u></p></div><div class="ordermenu" data-number="'+ordernumber+'" ><div class="panel-group"><div class="ordermenudown" ><a data-toggle="collapse" href="#collapse1 "><i class="fa fa-angle-down fa-lg">&nbsp;</i></a></div></div></div></div>';
             $('.orderdetail').append($html);
              
              
              childdchilddData.forEach(function(product) {
//                       var childData = product.key;
//        				  var get_data = product.val();
                
                		 var $name = product.product_name;
               			 var $custom = product.product_custom;
                		 var custom_link = product.product_link;
                
                if($name == '')
                {
 
        var  $newhtml =  '<div data-order="'+ordernumber+'" class="panel-collapse collapse"><div class="ALaptopSleevs"><a href="'+custom_link+'" target="_blank"><div class="image"><img src="https://cdn.shopify.com/s/files/1/2030/7295/files/no-image.png?1333788481347587492" style="width: 100%;"></a></div><div class="productDetail"><a href="'+custom_link+'" target="_blank"><b>'+$custom+'</b></a> </div></div></div>';
          $(".orderdetail").append($newhtml);
        	$(".no_order_yet").hide();
                  
          
                
                }
                    $(".all_products_box li").each(function(){
     			 var get_handle = $(this).attr("data-title").trim();
     			 var get_title = $(this).attr("data-title");
                    var url = $(this).attr("data-handle");
      			var get_image = $(this).attr("data-image");
      			var get_price = $(this).attr("data-price");
      			if(get_handle == $name  ){
                  
        			$(".no_order_yet").hide();
          			 var  $newhtml =  '<div data-order="'+ordernumber+'" class="panel-collapse collapse"><div class="ALaptopSleevs"><div class="image"><a target="_blank" href="/products/'+url+'"><img src="'+get_image+'" style="width: 100%;"></a></div><div class="productDetail"><a target="_blank" href="/products/'+url+'"><b>'+get_title+'</b></a> </div></div></div>';
          				$(".orderdetail").append($newhtml);
      			}
 
 
    });
                 
                     
              
              
              });
          }
          


        });


      });
    });
  });

//end code to get all data base values 
  
  
    
  
   var email = '';
   var orderid = '';
  
  // code to get specific data to edit the orders
      if(localStorage.getItem("email") != '')
      {
       email   = localStorage.getItem("email");
       orderid = localStorage.getItem("index");
//        var orderNumber = localStorage.getItem("orderNumber");
      }
 
  

    var username= email.substr(0, email.indexOf('@'));
   	var $link = '';
  	var $price='';
  	var $orderNumber = '';
 	var $total = '';
	var eventContactsRef = firebase.database().ref('users'); 
	eventContactsRef.orderByChild('email').equalTo(email)
    .once('value').then(function(snapshot) {
        snapshot.forEach(function(childSnapshot) {
        //remove each child
        
          childSnapshot.forEach(function(last) {
             
             	if(last.key == 'order' )
             	{
                 
                  
                  last.forEach(function(orders) {
                     
                    if(orders.key  == orderid){
                    
                      orders.forEach(function(orderdetail) {
                     
                        var key = orderdetail.key;
                        var data = orderdetail.val();
                         
                        if(key == 'ink' ) { $link = data;}//link pdf
                        if(key == 'order' ) { $orderNumber = data;}
                        if(key == 'order_price' ) { $total = data;}
                        
                        
                        if(key == 'products' ) {
                          $('#cust_email1').val(email);
                          $('#order_name1').val($orderNumber);
                          $('#order_price1').val($total);
                          $('#pdf_link1').val($link);
                           var counter = 0;

                          orderdetail.forEach(function(products) {
                            var key = products.val();
                          var $name = key.product_name;
                          var $custom = key.product_custom;
                              var $custom_link = key.product_link;
                            
                            counter = parseInt(counter)+1;
                            
                            if($name != ''){
                            
                              $(".product-select:nth-child("+counter+") > div > select option").each(function()
								{
                             if( $(this).text() == $name  )
                             {
                              $(this).attr('selected', true);
                               $(this).parent().parent().parent().addClass('active-product');
                              }
                            });
                              
                            }
                            else
                            {
                            
                           $(".product-select:nth-child("+counter+") > div > select option").each(function()
								{
                             if( $(this).text() == 'Other'  )
                             {
                              $(this).attr('selected', true);
                               $(this).parent().parent().parent().addClass('active-product');
                                $('<input class="customproduct" placeholder="Product title" name="customproduct" required="" value="'+$custom+'" type="text"><input class="customproductlink" placeholder="Product Link" name="customproductlink" value="'+$custom_link+'" required="" type="text">').insertAfter(".product-select:nth-child("+counter+") .addButton");
                              }
                             
                             
                            });
                              
                            
                            }
                          
                          
                          });
                        }
                        
                      
                      });
                    }
                  });
                
             }
          
          });
//        
      });
	});

    function getimge_url(set_path){

    var storage = firebase.storage();
    var storageRef = storage.ref();
    storageRef.child(set_path).getDownloadURL().then(function(url) {
      // `url` is the download URL for 'images/stars.jpg'

      // This can be downloaded directly:
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function(event) {
        var blob = xhr.response;
      };
      xhr.open('GET', url);
      xhr.send();

      //       Or inserted into an <img> element:
      return url;
       
    }).catch(function(error) {
      console.log(error);
    });

  }
 
 
  
    function profile_image(set_path){

                  var forimage= set_path.substr(0, set_path.indexOf('@'));
     
                 var storage = firebase.storage();
                  var storageRef = storage.ref();
                  storageRef.child(forimage).getDownloadURL().then(function(url) {
                    var xhr = new XMLHttpRequest();
                    xhr.responseType = 'blob';
                    xhr.onload = function(event) {
                      var blob = xhr.response;
                    };
                    xhr.open('GET', url);
                    xhr.send();
 
                     console.log(url+'urlll');
                    $('.'+forimage).attr('src',url);
                      
      					 
  					 		 
                  }).catch(function(error) {
                    console.log(error);
                  });

  }
  $('#set_customer_image').hide();

  function getimge_url(set_path){

    var storage = firebase.storage();
    var storageRef = storage.ref();
    storageRef.child(set_path).getDownloadURL().then(function(url) {
      // `url` is the download URL for 'images/stars.jpg'

      // This can be downloaded directly:
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function(event) {
        var blob = xhr.response;
      };
      xhr.open('GET', url);
      xhr.send();

      //       Or inserted into an <img> element:
      var img = document.getElementById('set_customer_image');
      img.src = url;
        $('#set_customer_image').show();
    }).catch(function(error) {
      console.log(error);
    });

  }

  function order_handles(get_handle,childData){   
      var pass_handle = get_handle;
      append_order_history(pass_handle,childData);
  }
  
  
  function get_order_no(id_no,childData){
    $(".order-grid#"+childData).prepend('<div class="orderNo">Order#: '+id_no+'</div>');

  }
  function get_order_link(id_no,childData){
    $(".order-grid#"+childData).prepend('<div class="order_link">PDF:'+'<a target="_blank" href="'+id_no+'">Link</a>'+'</div>');

  }
  function get_order_price(id_no,childData){      
    $("#customerLogin").append('<div class="order_price" data-price="'+id_no+'">'+id_no+'</div>');



  }
  
  

 
});


